import { type Association } from "@entities";
import { Stack } from "@mui/material";
import type { FC } from "react";
import { type CustomCell } from "./types";

const Insurance: FC<CustomCell<Association>> = ({ row, column }) => {
  return (
    <Stack flexDirection="row" alignItems="center" justifyContent="center">
      <span title={row.original.user?.numberID ? "קיים" : "אינו קיים"}>
        <img
          src={`/${row.original.user?.numberID ? "green-shield" : "red-shield"}.svg`}
          alt={row.original.user?.numberID ? "ביטוח קיים" : "ביטוח אינו קיים"}
        />
      </span>
    </Stack>
  );
};

export default Insurance;
